/*jshint esversion: 9 */
/**
 * http请求配置
 */
import axios from "axios";
import Const from "./Const";
import router from '@/router';
import { ElMessage} from 'element-plus'
export const service = axios.create({  //可创建多个 axios实例
    baseURL: Const.baseApiURL, //设置公共的请求前缀
    timeout: Const.timeout, //超时终止请求
});
service.interceptors.request.use(
    config => {
        config.headers = config.headers
        if (config.method === 'post') {
            config.data = {
                ...config.data
            }
        } else if (config.method === 'get') {
            config.params = {
                ...config.params
            }
        }
        return config;
    },
    () => {
        return Promise.reject({
            msg: '请求发生错误，请稍后再试',
        });
    },
);

service.interceptors.response.use(
    response => {
        const data = response.data;
        if(!data){
            return Promise.reject({
                msg: '请求发生错误',
            });
        }
        const status = data.code;
        switch (status) {
            case 1:
                return Promise.resolve(data);
            default:
                ElMessage.error(data.msg || 'Request failed');
                return Promise.reject(data);
        }
    },
    () => { //数据请求发生错误
        ElMessage.error('Request failed, please try again later.');
        return Promise.reject({
            msg: 'Request failed, please try again later.',
        });
    },
);